import React, {lazy} from "react";
import { withTranslation } from "react-i18next";
import {Link} from "react-router-dom";
import {generatePath} from "react-router";
import ReactSVG from "react-svg";
import {animateScroll as scroll} from "react-scroll";

const MapPopup = lazy(() => import("../MapPopup/MapPopup"));

import "../../ButtonLink/button.scss";
import arrowButton from "../../ButtonLink/arrow-button.svg";


import "./RestaurantMapPopup.scss";
import {useSelector} from "react-redux";
import {getMapObjectsSize} from "../../../store/slices/restaurantSearchSlice";

export const BASE_RESTAURANT_MAP_POPUP_OFFSET = 90;

const RestaurantMapPopup = (props) => {

    const {
        t,
        restaurant,
        onClose
    } = props;

    const mapObjectsSize = useSelector(getMapObjectsSize);

    function scrollToTop() {
        setTimeout(function() {
            scroll.scrollToTop({duration: 0});
        }, 450)
    }

    return (
        <MapPopup
            longitude={restaurant.lng}
            latitude={restaurant.lat}
            anchor="bottom"
            closeButton={true}
            closeOnClick={true}
            offset={mapObjectsSize?.restaurantMapPopupOffsset || BASE_RESTAURANT_MAP_POPUP_OFFSET}
            onClose={onClose}
            className="idg-restaurant-map-popup"
        >
            { !!restaurant.recommended &&
                <div className="recommended-popup">
                    <h6>{ t('idg.recommended') }</h6>
                </div>
            }

            <div className="information-popup">
                <h5>{ restaurant.name }</h5>

                <address>{ restaurant.address }, {restaurant.city} ({restaurant.province.code})</address>

                <Link
                    onClick={scrollToTop}
                    to={ generatePath(t("idg.restaurant.href"), { id: restaurant.id, slug: restaurant.slug }) }
                    className="btn btn--white btn--arrow"
                >
                    <span>{t('idg.readMore')}</span>
                    <ReactSVG src={arrowButton} />
                </Link>
            </div>

        </MapPopup>
    )
};

export default withTranslation("idg")(RestaurantMapPopup);

